"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.REQUIRED_PASSWORD_CODE = exports.MFA_REQUEST_CODE = exports.LOGIN_SECTION_DEFAULT_TEXTS = void 0;
exports.LOGIN_SECTION_DEFAULT_TEXTS = {
    or: 'Or',
    formTitle: 'Please log in',
    actionSSO: 'Log in with Single Sign-On',
    actionLocalUsers: 'Use local users',
    verificationMFATitle: 'Verification'
};
exports.MFA_REQUEST_CODE = '__MFA_REQUEST_CODE__';
exports.REQUIRED_PASSWORD_CODE = '__REQUIRED_PASSWORD_CODE__';
//# sourceMappingURL=constants.js.map